import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import { format, parseISO } from 'date-fns';
import { RiTimeFill } from 'react-icons/ri';

const BlogCard = ({ blog }) => {
  const { slug, coverImage, title, publishedAt, externalLink, shortDescription } = blog;

  const shortenText = (input) => (input?.length > 80 ? `${input.substring(0, 80)}...` : input);

  const shortenTitle = (input) => (input?.length > 45 ? `${input.substring(0, 45)}...` : input);

  return (
    <Link
      to={externalLink ? externalLink : `/blog/${slug}`}
      target={externalLink ? '_blank' : ''}
      className='blog-card'
    >
      <Img fluid={coverImage.fluid} objectFit='cover' />
      <div className='info'>
        <h3>{shortenTitle(title)}</h3>
        <p className='date'>
          <span>
            <RiTimeFill />
          </span>
          <span>{format(parseISO(publishedAt), 'do MMM, yyyy')}</span>
        </p>
        <p className='shortDescription'>{shortenText(shortDescription)}</p>
      </div>
    </Link>
  );
};

export default BlogCard;
